import type { RootState } from "@/store/types";
import { createSelector } from "@reduxjs/toolkit";

const selectGlobal = (state: RootState) => state.global;

export const GlobalSelectors = {
  user: createSelector(selectGlobal, (global) => global.user),
  isAuthenticated: createSelector(
    selectGlobal,
    (global) => global.isAuthenticated
  ),
  isLoading: createSelector(selectGlobal, (global) => global.isLoading),
  isAdmin: createSelector(selectGlobal, (global) => global.user?.isAdmin ?? false),
  error: createSelector(selectGlobal, (global) => global.error),
  isLoginPromptOpen: createSelector(
    selectGlobal,
    (global) => global.isLoginPromptOpen
  ),
};
